<template>
  <div v-if="item">
    <div class="row">
      <div class="col">
        <ez-s3-image v-if="item" :item="item" />
      </div>
      <div class="col">
        <ez-text-area-md v-model="item.description" rows="8">Description</ez-text-area-md>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EzS3Image from "../shared/_VueEzS3Image.vue";
import EzTextAreaMd from "../shared/_VueEzTextAreaMd.vue";

export default {
  name: "image-form",
  components: {
    EzS3Image,
    EzTextAreaMd
  },
  props: ["item", "errors"],
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin"
    })
  }
};
</script>
